import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChargeConfigService {

  constructor(private http: HttpClient) {}
  
    getAllChargeConfig() {
      return this.http.get(`${environment.apiUrl}/charge-config/get-all`);
    }
  
    updateChargeConfig(id: string, data: any) {
      return this.http.put(`${environment.apiUrl}/charge-config/update/${id}`, data);
    }
}
